export default "__VITE_PUBLIC_ASSET__8501cfdb__"